/**
 * Lê o modo de CTA da landing em `APP_CONFIG/LANDING_CTA`.
 *
 * Mesmo padrão de `services/adsCatalog.js`: `getDoc` avulso, cache no módulo,
 * e defaults no lugar do que falhou. Sem listener — o modo muda por decisão de
 * marketing, não a cada segundo, e um `onSnapshot` aberto na landing manteria
 * conexão viva para todo visitante do site.
 *
 * NUNCA DEVOLVE ESTADO INDEFINIDO. Começa já em `MODO_PADRAO` (que é `APP`), e
 * só troca se o documento disser outra coisa. Assim os botões nascem
 * funcionando em vez de piscar desabilitados enquanto a rede responde — numa
 * landing, meio segundo de botão morto é visita perdida.
 *
 * A LEITURA É PÚBLICA porque a landing é servida antes de qualquer login: a
 * rule de `APP_CONFIG/LANDING_CTA` libera `read` como já faz com
 * `APP_CONFIG/APP_VERSION`. O documento não tem dado de usuário nem segredo —
 * é uma palavra.
 */

import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { CAMINHO, MODO_PADRAO, resolverModo } from './modoDoCta';

let _cache = null;

/** Exportado para o teste poder começar limpo. */
export function limparCacheDoModo() {
  _cache = null;
}

export async function lerModoDoCta() {
  if (_cache) return _cache;
  try {
    const snap = await getDoc(doc(db, CAMINHO[0], CAMINHO[1]));
    _cache = resolverModo(snap.exists() ? snap.data() : null);
  } catch {
    // Offline, rule fechada, projeto mal configurado: a landing não pode
    // depender disso para ter um botão que funciona.
    _cache = MODO_PADRAO;
  }
  return _cache;
}

export default function useModoDoCta() {
  const [modo, setModo] = useState(_cache || MODO_PADRAO);

  useEffect(() => {
    let cancelado = false;
    lerModoDoCta().then((m) => {
      if (!cancelado) setModo(m);
    });
    return () => { cancelado = true; };
  }, []);

  return modo;
}
